import { render, staticRenderFns } from "./VarietyStatistics.vue?vue&type=template&id=14feee22&"
import script from "./VarietyStatistics.vue?vue&type=script&lang=js&"
export * from "./VarietyStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports